// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KI2Fm","option":"styles_option__1NyB5","selected":"styles_selected__2A-DV"};